<template>
  <div class="box  box--gray">

    <ul class="box__list">
      <li class="box__list-item">
        <div>{{ in18['page_summary_product_quantity'] }}</div>
        <span>{{ cart.total_quantity }}</span>
      </li>
      <li class="box__list-item">
        <div>{{ in18['page_summary_price_without_tax'] }}</div>
        <span>{{ cart.formatted_total_price }}</span>
      </li>
      <li class="box__list-item">
        <div>{{ in18['page_summary_tax_rate'] }}</div>
        <span>{{ cart.formatted_tax_price }}</span>
      </li>
    </ul>

    <!--    <div v-if="cart.shipping_price_with_tax > 0" class="box__section">-->
    <!--      <ul class="box__list">-->
    <!--        <li class="box__list-item">-->
    <!--          <div>{{ in18['page_summary_shipping'] }}</div>-->
    <!--          <span>-->
    <!--            {{ cart.formatted_shipping_price_with_tax }}-->
    <!--          </span>-->
    <!--        </li>-->
    <!--      </ul>-->
    <!--    </div>-->

    <div v-if="cart.coupon_total_price_with_tax > 0" class="box__section">
      <ul class="box__list">
        <li class="box__list-item">
          <div>{{ in18['page_summary_discount_price_wit_tax'] }}</div>
          <span class="discount_total_price">
            - {{ cart.formatted_coupon_total_price_with_tax }}
          </span>
        </li>
      </ul>
    </div>

    <div class="box__section">
      <ul class="box__list">
        <li class="box__list-item  box__list-item--accent">
          <div>{{ in18['page_summary_total_price'] }}</div>
          <div><b class="text-dark">{{ cart.formatted_total_price_with_tax }}</b></div>
        </li>
      </ul>
      <a
        v-if="cart.available_for_purchase"
        :href="checkout_route"
        class="btn btn--red btn--block btn--sm"
      >
      {{ in18['page_summary_process_checkout_btn'] }}
    </a>
<span
  v-else
  class="btn btn--red btn--block btn--sm opacity-50 cursor-not-allowed"
>
  {{ in18['page_summary_process_checkout_btn'] }}
</span>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    checkout_route: {
      type: String
    },
    cart:           {
      type: Object
    },
    in18:           {
      type: Object
    }
  },
};
</script>
